import React from 'react';

const ScrollView = (props) => {
  return (
    <div className="scrollView">
      <div className="scrollView__scroller">
        {props.children}
      </div>
    </div>
  )
};

export default ScrollView;



// WEBPACK FOOTER //
// ./src/components/scrollview.js